const e = "en", n = "Terug", o = "Sluiten", a = "Doorgaan", r = "dagen", i = "d", t = "E-mail", s = "Hallo", l = "uur", d = "u", g = "minuten", u = "min", X = "geen", c = "Optioneel", m = "Registreren", v = "seconde", h = "s", b = "Door op deze link te klikken gaat u akkoord om nieuws & promoties van ons hotel te ontvangen. In overeenstemming met de AGV wet (Algemene Verordening Gegevensbescherming) willen we u informeren dat uw gegevens worden opgenomen in onze databases. Als een klant van ons kan u altijd uw eigen persoonsgegevens waar wij over beschikken inkijken en uw rechten uitoefenen als de eigenaar van de gegevens in overeenstemming met de AGV wetgeving.", k = "Ik accepteer de Algemene voorwaarden", p = {
  "(Optional)": "(Valgfri)",
  and: e,
  "Apply promocode": "Promocode toepassen",
  "Are you registered?": "Ben je geregistreerd?",
  Back: n,
  "Book Now": "Boek nu",
  "Call Now": "Bel Nu",
  "Click here": "Klik hier",
  Close: o,
  "Confirm your email": "Bevestig uw e-mail",
  "Contact Now": "Contact Nu",
  Continue: a,
  days: r,
  days_abbr: i,
  Email: t,
  "Enter the validation code sent to your email": "Voer de validatiecode in die je per e-mail hebt ontvangen",
  "Exclusive benefits unlocked!": "Exclusieve voordelen vrijgespeeld!",
  "Great! Email successfully sent!": "Super goed! E-mail succesvol verzonden!",
  Hello: s,
  hours: l,
  hours_abbr: d,
  "I agree to the": "Ik ga akkoord met de",
  "Invalid code": "Ongeldige code",
  "Last reservation was XXXXXX hours ago": "Laatste reservering was XXXXXX uur geleden",
  minutes: g,
  minutes_abbr: u,
  none: X,
  "Not registered yet?": "Nog niet geregistreerd?",
  "Only for registered users": "Alleen voor geregistreerde gebruikers",
  "Only for specific rates": "Alleen voor specifieke prijzen",
  Optional: c,
  "Perk 1 will be listed here": "Perk 1 wordt hier weergegeven",
  "Perk 2 will be listed here": "Perk 2 wordt hier vermeld",
  "Perk 3 will be listed here": "Perk 3 wordt hier vermeld",
  "Please, provide a valid e-mail": "Geef a.u.b. een geldig e-mailadres op",
  "Privacy policy": "Privacybeleid",
  Register: m,
  "Resend code": "Code opnieuw verzenden",
  seconds: v,
  seconds_abbr: h,
  "Send to booking engine": "Verzenden naar reserveringssysteem",
  "Sending search": "E-mail wordt verzonden",
  "Sign in": "Aanmelden",
  "Sign in to your account": "Log in op uw account",
  "Something went wrong. Please, try again later.": "Er was een probleem. Probeer het later opnieuw.",
  "Subject to availability": "Onder voorbehoud van beschikbaarheid",
  "Terms and conditions": "Voorwaarden en condities",
  Terms_default: b,
  Terms_default_label: k,
  "Thank you!": "Dank u wel!",
  "There are XXXXXX people looking at this hotel right now": "Momenteel kijken XXXXXX mensen naar dit hotel",
  "There has been an error.": "Er is een fout opgetreden.",
  "This is a standard paragraph, use it to display information.": "Dit is een standaardparagraaf, gebruik hem om informatie weer te geven.",
  'This is paragraph. <b>Bold</b> it, <i>italicise</i> it, <u>underline</u> it, add <a href="#">links</a>, emojis 🙂, and more!': `Dit is paragraaf. <b>Vet</b> het, <i>cursiveer</i> het, <u>onderstreep</u> het, voeg <a href="#">links</a>, emoji's 🙂 en meer toe!`,
  "Title of your message": "Titel van uw bericht",
  "Today's special offer: XXXXXX": "De special aanbieding van vandaag: XXXXXX",
  "View all XXXXXX perks": "Alle extraatjes van XXXXXX bekijken",
  "We have received your form submission correctly": "We hebben het formulier goed ontvangen.",
  "We will send you an email with your search very soon.": "We sturen je zo snel mogelijk een e-mail met je zoekopdracht",
  "Web exclusive": "Exclusieve webaanbieding",
  "XXXXXX people have already booked today": "XXXXXX mensen hebben vandaag al geboekt",
  "XXXXXX people have looked at this hotel today": "XXXXXX mensen hebben vandaag naar dit hotel gekeken",
  "XXXXXX% discount only today": "XXXXXX% korting alleen vandaag",
  "You must agree to the Terms & Conditions first": "U moet eerst akkoord gaan met de algemene voorwaarden",
  "Your email": "E-mail",
  "Your email address has been successfully added to our list.": "Uw e-mailadres is succesvol toegevoegd aan onze lijst."
};
export {
  n as Back,
  o as Close,
  a as Continue,
  t as Email,
  s as Hello,
  c as Optional,
  m as Register,
  b as Terms_default,
  k as Terms_default_label,
  e as and,
  r as days,
  i as days_abbr,
  p as default,
  l as hours,
  d as hours_abbr,
  g as minutes,
  u as minutes_abbr,
  X as none,
  v as seconds,
  h as seconds_abbr
};
//# sourceMappingURL=nl.BXN77qDs.js.map
